import { render } from "./userinfoCollect.vue?vue&type=template&id=2fd6dbfb"
const script = {}

import "./userinfoCollect.vue?vue&type=style&index=0&id=2fd6dbfb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__